export const policyActions = {
  populatePolicies: "POPULATE_POLICIES"
};
